"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var thankyouEgg = {
    name: "thankyou",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["t", "h", "a", "n", "k", "y", "o", "u"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/AROO6Pl.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "600px";
        img.style.height = "300px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 300px)";
        img.style.bottom = "-300px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "-30px";
        }, 50);
        window.setTimeout(function () {
            img.style.bottom = "-300px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            // shock.parentNode!.removeChild(shock);
        }, 5400);
    },
};
exports.default = thankyouEgg;
